
import { Vue } from "vue-class-component";

export default class PlusIcon extends Vue {}
